import ApiService from '@/api/http/ApiService';
import axios, { AxiosPromise } from 'axios';

export default class KostApiService extends ApiService<any> {
  constructor() {
    super('kost', 'v1');
  }

  public syncFoodcard(payload: { venue: string }): AxiosPromise<void> {
    return axios.post(`${this.getBaseUrl()}/sync`, payload);
  }
}
